// src/components/ui/Input.tsx
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input: React.FC<InputProps> = (props) => {
  return <input {...props} style={styles.input} />;
};

const styles = { 
  input: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '12px 25px',
    height: '52px',
    border: '1px solid #474747',
    borderRadius: '12px',
    fontSize: '14px',
  } as React.CSSProperties,
  /* src/components/ui/Input.css */



};

export default Input;
